import * as React from "react";

import "./listing-records-mobile.scss";

import {cs}       from "@Common/react/chain-services";
import {keyed}    from "@Common/react/keyed";
import {UseState} from "@Common/react/use-state";

import {MobileViewCard} from "../card/mobile-view-card";
import {Select1}        from "../common/select1/select1";

export const ListingRecordsMobile = ({viewType, listings, onCreateMarketingMaterials}) => cs(
    () => (
        <div className="listing-records-mobile-84e">

            <div className="list">
                {listings.map((record, i) =>
                    cs(
                        keyed(i),
                        ({}) => MobileViewCard({record, onCreateMarketingMaterials}),
                    )
                )}
            </div>
        </div>
    )
);

